import { createContext, PropsWithChildren, useContext } from "react";
import { useParams } from "react-router-dom";
import { Loading } from "@/components/atoms";
import { NotFound } from "@/components/pages";
import { useGetVehicleCategoryQuery } from "@/redux/apis/config/trip/vehicleCategory/vehicleCategoryApi";
import { VehicleCategory } from "@/redux/slices/vehicle/types";

export interface IEditVehicleCategory {
  vehicleCategory: VehicleCategory;
}
export const EditVehicleCategoryContext = createContext<IEditVehicleCategory | null>(null);

export const EditVehicleCategoryProvider = ({ children }: PropsWithChildren) => {
  const { vehicleCategoryId } = useParams<{ vehicleCategoryId: string }>();

  const { data: vehicleCategory, isFetching, isError } = useGetVehicleCategoryQuery(vehicleCategoryId ?? "", { skip: !vehicleCategoryId });
  if (isError) return <NotFound noBackground noHeader />;
  if (isFetching || !vehicleCategory) return <Loading />;

  return <EditVehicleCategoryContext.Provider value={{ vehicleCategory }}>{children}</EditVehicleCategoryContext.Provider>;
};

export const useEditVehicleCategoryContext = () => {
  const context = useContext(EditVehicleCategoryContext);
  if (!context) {
    throw new Error("useEditVehicleCategoryContext must be used within an EditVehicleProvider");
  }
  return context;
};
